const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  clientList: state => state.user.clientList,
  websocketConnected: state => state.user.websocketConnected,
  printVersion: state => state.user.printVersion,
  // 通知权限状态
  hasNotificationPermission: state => state.permission.hasNotificationPermission,
  // 资源引用域名
  // baseHostCn: () => "http://172.29.1.111/",
  // baseHostCom: () => "http://172.29.1.111/"
  baseHostCn: () => "https://www.ai2tcm.cn/",
  baseHostCom: () => "https://www.ai2tcm.com/"
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js